<template>
    <footer>
        <div class="footer-widget-area section-padding" :class="FooterStyle">
            <div class="container">
                <div class="row mtn-40">
                    <div class="col-lg-4">
                        <div class="widget-item">
                            <h5 class="widget-title">Rreth Nesh</h5>
                            <div class="widget-body">
                                <ul class="widget-info">
                                    <li><strong>Adresa :</strong><span>Rruga e spitalit ,pallati me kollona të rrumbullakta, përballë hotel Internacional Fier.</span></li>
                                    <li><strong>Telefon :</strong>068 903 2160</li>
                                    <li><strong>Email :</strong>info@helios-med.com</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="widget-item">
                            <h5 class="widget-title">Sherbimet tona</h5>
                            <div class="widget-body">
                                <ul class="widget-info useful-link">
                                    <li><a href="#">Analiza Biokimike</a></li>
                                    <li><a href="#">Analiza Mikrobiologjike</a></li>
                                    <li><a href="#">Analiza Imunologjike</a></li>
                                    <li><a href="#">Analiza Hematologjike</a></li>
                                    <li><a href="#">Analiza Hormonale</a></li>
                                    <li><a href="#">Etj</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="widget-item">
                            <h5 class="widget-title">Abonohuni ne Helios Med</h5>
                            <div class="widget-body newsletter-widget">
                                <p>Deshironi te merrni njoftimet ose ofertat nga nga Helios Med?</p>
                                <form class="newsletter-form">
                                    <input type="text" class="newsletter-field" placeholder="Email-i juaj">
                                    <button type="submit" class="subscribe-btn">Abonohuni</button>
                                </form>
                                <ul class="footer-social-link">
                                    <li v-for="(social, socials) in socials" :key="socials">
                                        <a :href="social.url"><i :class=social.icon></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom light-blue-bg" :class="FooterStyle">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 order-2 order-md-1">
                        <div class="copyright">
                            <p>Copyright © <a href="#">Helios Med</a>. Te gjitha te drejtat e rezervuara</p>
                        </div>
                    </div>
                    <div class="col-md-6 order-1 order-md-2">
                        <div class="useful-link">
                           Krijuar nga: <a href="https://github.com/refail">Refail Gjeli</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterTwo',
    props: ["FooterStyle"],
    data () {
        return {
            socials: [
                {icon: "fa fa-facebook",url:'https://www.facebook.com/heliosmedlab/?ref=br_rs'},
                {icon: "fa fa-instagram",url:'https://www.instagram.com/heliosmedlab_1/'},
            ]
        }
    }
}
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/footer.scss';
</style>
